import React from "react";
import "./sectionHeading.scss";
const SectionHeading = ({ varient, title, children }) => {
  return (
    <div
      className={
        varient ? `section_heading ${varient}` : "section_heading"
      }
    >
      <h2 className="section_heading_title">{title}</h2>
      {children}
    </div>
  );
};

export default SectionHeading;
